import { trigger, state, style, transition, animate, AnimationTriggerMetadata } from '@angular/animations';

export const Animations = {
    fadeOut(timingIn: number): AnimationTriggerMetadata {
        return trigger('fadeOut', [transition('* => *', [animate(timingIn, style({ opacity: 0 }))])]);
    },
    fadeIn(timingIn: number): AnimationTriggerMetadata {
        return trigger('fadeIn', [transition('* => *', [animate(timingIn, style({ opacity: 1 }))])]);
    },
    fadeOutWhenTrue(timingIn: number): AnimationTriggerMetadata {
        return trigger('fadeOut', [transition('false => true', [animate(timingIn, style({ opacity: 0 }))])]);
    },
    fadeInWhenFalse(timingIn: number): AnimationTriggerMetadata {
        return trigger('fadeIn', [transition('true => false', [animate(timingIn, style({ opacity: 1 }))])]);
    },
};
